<template>
  <div class="general-info-detail-wrap">
    <div class="header-wrap">
      <div class="title">{{ resultList.monitor_name }}</div>
      <div class="other">
        <span class="time">发布时间：{{ resultList.date_range }}</span>
        <span class="white"></span>
        <span class="origin">阅读：{{ resultList.read_count }}</span>
      </div>
    </div>
    <div class="detail-content">
      <div>
        <TitleCard title="本期最新专利概况" class="infoItem" :showMore="false">
        </TitleCard>
        <div class="item-content">
          <div>
            {{ resultList.monitor_name }}（{{
              resultList.date_range
            }}）最新公开专利申请共{{ patentTotal }}件,{{ patentStr }}。
          </div>
          <Pie :options="pieEchartOptions" ref="pieChartsInstance"></Pie>
        </div>
      </div>
      <div>
        <TitleCard title="本期主要申请人" class="infoItem" :showMore="false">
        </TitleCard>
        <div>
          <div>
            本期新公开专利中以下申请人申请专利数量较多。（默认显示按公开数据降序排列后，取前十位显示，相同数量排序不分先后）
          </div>
          <a-table
            :columns="fields"
            :data-source="patentData"
            :pagination="false"
            bordered
            class="table"
          >
          </a-table>
        </div>
      </div>
      <div>
        <TitleCard title="本期主要发明人" class="infoItem" :showMore="false">
        </TitleCard>
        <div class="item-content">
          <div>
            本期新公开专利中以下发明人申请专利数量TOP10（默认显示按公开数据降序排列后，取前十位显示，相同数量排序不分先后）
          </div>
          <inventorBar
            :options="inventorBarOptions"
            ref="inventChartsInstance"
          ></inventorBar>
        </div>
      </div>
      <div>
        <TitleCard title="本期主要技术热点" class="infoItem" :showMore="false">
        </TitleCard>
        <div class="item-content">
          <div>本期新公开专利的主要技术热点领域集中在：{{ categoryStr }}。</div>
          <categoryBar
            :options="categoryBarOptions"
            ref="categoryChartsInstance"
          ></categoryBar>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getIndustryDetailInfo } from '@/api/IpProject.js'
import Pie from '@/components/echarts/Pie'
import inventorBar from '@/components/echarts/Bar'
import categoryBar from '@/components/echarts/Bar'
import { fields } from '../configs/config'
import { colorArr } from '@/components/echarts/tools'
export default {
  data() {
    return {
      resultList: {},
      pieEchartOptions: null, // 最新专利饼图
      patentTotal: 0, // 专利总量
      patentStr: '',
      fields,
      patentData: [], // 申请人表格数据
      inventorBarOptions: null, // 发明人柱状图
      categoryBarOptions: null, // 技术热点柱状图
      categoryStr: ''
    }
  },
  components: {
    Pie,
    inventorBar,
    categoryBar
  },
  created() {
    this.loadData()
  },
  methods: {
    getPieOpt(data) {
      return {
        tooltip: {
          trigger: 'item'
        },
        series: [
          {
            name: '',
            type: 'pie',
            radius: '50%',
            data: data,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ],
        color: colorArr
      }
    },
    getBar(xData, yData, colorArr, val, list) {
      return {
        xAxis: {
          type: 'category',
          data: xData,
          axisLabel: {
            interval: 0
          }
        },
        yAxis: {
          type: 'value',
          axisLine: {
            show: true
          }
        },
        tooltip: {
          trigger: 'item',
          formatter: params => {
            //
            let str = ''
            if (val === 'category') {
              str =
                list[params.dataIndex].name +
                '</br>' +
                params.marker +
                ' ' +
                params.name +
                '&nbsp;&nbsp;&nbsp;&nbsp;' +
                params.value
            } else {
              str =
                params.marker +
                ' ' +
                params.name +
                '&nbsp;&nbsp;&nbsp;&nbsp;' +
                params.value
            }
            return str
          }
        },
        series: [
          {
            data: yData,
            type: 'bar',
            label: {
              show: true,
              position: 'outside',
              color: colorArr
            }
          }
        ],
        color: colorArr
      }
    },
    async loadData() {
      const { id } = this.$route.query
      const { data } = await getIndustryDetailInfo(id)
      this.resultList = data
      // 最新专利
      let patent_type_data = JSON.parse(this.resultList.patent_type_data)
      patent_type_data.forEach(item => {
        this.patentTotal += Number(item.value)
      })
      patent_type_data.forEach(item => {
        this.patentStr =
          this.patentStr +
          `；${item.name}${item.value}件,占比${(
            item.value / this.patentTotal
          ).toFixed(2) * 100}%`
      })
      this.pieEchartOptions = this.getPieOpt(patent_type_data)

      // 申请人表格
      let patentData = JSON.parse(this.resultList.patentee_data)
      patentData.forEach((item, index) => {
        item.key = index + 1
      })
      this.patentData = patentData
      this.patentStr = this.patentStr.slice(1)

      // 发明人
      let inventorXData = []
      let inventorYData = []
      let inventorData = JSON.parse(this.resultList.inventor_data)
      inventorData.forEach(item => {
        inventorXData.push(item.name)
        inventorYData.push(item.value)
      })
      this.inventorBarOptions = this.getBar(
        inventorXData,
        inventorYData,
        colorArr[0],
        '',
        inventorData
      )
      console.log(this.inventorBarOptions)
      // 技术热点
      let categoryXData = []
      let categoryYData = []
      let categoryData = JSON.parse(this.resultList.category_data)
      categoryData.forEach(item => {
        categoryXData.push(item.code)
        categoryYData.push(item.value)
      })
      this.categoryBarOptions = this.getBar(
        categoryXData,
        categoryYData,
        colorArr[1],
        'category',
        categoryData
      )
      categoryData.slice(0, 3).forEach(item => {
        this.categoryStr += `、${item.code}(${item.name})`
        this.categoryStr = this.categoryStr.slice(1)
      })
      console.log(this.categoryBarOptions)
      this.$nextTick(() => {
        this.$refs.pieChartsInstance.initChart()
        this.$refs.inventChartsInstance.initChart()
        this.$refs.categoryChartsInstance.initChart()
      })
    }
  }
}
</script>
